export const stickerItemEn = {
  choosePlanWarn: 'Please, choose plan value'
}

export const stickerItemRu: typeof stickerItemEn = {
  choosePlanWarn: 'Укажите план для задачи'
}
